<h2 mat-dialog-title>Confirmation</h2>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
  <p *ngIf="data.details">{{ data.details }}</p>
</div>
<div mat-dialog-actions align="center">
  <button mat-flat-button class="m-2" color="primary" [mat-dialog-close]="true">
    Confirmer
  </button>
  <button mat-flat-button class="m-2" color="primary" (click)="onNoClick()">Annuler</button>
</div>
